export { default } from './OmiseTesco'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseTesco/index.js